module.exports = __webpack_public_path__ + "static/share_index-6cbc3d8b3800e8d99e25f5be4616c64a.jpg";